import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PageHero";

export const LegalBody = ({ sections, updated }) => (
  <section className="bg-white py-14 md:py-20">
    <div className="mx-auto max-w-3xl px-6">
      <p className="text-sm text-slate-500" data-testid="legal-updated">Last updated: {updated}</p>
      <div className="mt-6 space-y-10">
        {sections.map(([h, ps]) => (
          <div key={h}>
            <h2 className="font-display text-2xl font-bold text-[var(--navy)]">{h}</h2>
            {ps.map((p, i) => <p key={i} className="mt-3 leading-relaxed text-[var(--body)]">{p}</p>)}
          </div>
        ))}
      </div>
    </div>
  </section>
);

const SECTIONS = [
  ["Who we are", ["Easy Handyman Services provides property maintenance services throughout Oxfordshire, UK. You can contact us at easyhandymanservicesuk@gmail.com or on 07836 207134."]],
  ["What we collect", ["When you send a quote request or message through this website, we collect the details you provide: your name, phone number, email address, property postcode, the service you're interested in, a description of the work, your preferred date and any photos you choose to upload."]],
  ["How we use it", ["We use your details only to respond to your enquiry, prepare a quotation and arrange and carry out any work you ask us to do. We do not sell your information or use it for unrelated marketing."]],
  ["Lawful basis", ["We process your information because you have asked us to take steps before entering into a contract (providing a quote), and for our legitimate interest in responding to enquiries."]],
  ["How it's stored", ["Enquiries are delivered to our business email inbox. Photos you upload are stored securely and are only accessible through private links sent to us. We keep enquiry information only for as long as needed to deal with your request and any resulting work."]],
  ["Your rights", ["Under UK GDPR you can ask to access, correct or delete the personal information we hold about you, or object to how we use it. To make a request, email easyhandymanservicesuk@gmail.com. You also have the right to complain to the Information Commissioner's Office (ico.org.uk)."]],
  ["Changes", ["We may update this policy from time to time. The latest version will always be on this page."]],
];

export default function Privacy() {
  return (
    <>
      <Seo title="Privacy Policy | Easy Handyman Services" description="How Easy Handyman Services collects, uses and protects the personal information you share through our website and quote form." />
      <PageHero testId="privacy-hero" eyebrow="Legal" lines={["Privacy Policy"]} />
      <LegalBody sections={SECTIONS} updated="3 November 2026" />
    </>
  );
}
